<section class="shift-otp-align">
  <form>

      <h2>Please enter your mobile number or email id</h2>
    <div class="form-group">
    <input type="text" id="Username" [(ngModel)]="register.mobile" class="form-control"
           [ngClass]="{'is-invalid':errorMessage}" placeholder="yourname@email.com"
           (blur)="onSelectEmail()" [ngModelOptions]="{standalone: true}" required>

    <div id="statusText1" class="invalid-feedback d-block shift-invalid-login"
         [hidden]="!errorMessage">{{errorMessage}}</div>
    </div>
        <button (click)="forgotPasswordRequest()" class="btn btn-orange mb-4 btn-block">Submit</button>
    <div class="mb-5 forgot">
      <a routerLink="/access/login">Back to Login</a>
    </div>
    </form>
</section>
